/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import moment from 'moment/moment';
import React, {
  useState, useEffect,
} from 'react';
import Input from '../../../components/forms/input';
import Textarea from '../../../components/forms/Textarea';
import InputPrepend2 from '../../../components/forms/InputPrepend2';
import 'react-toastify/dist/ReactToastify.css';
import 'react-quill/dist/quill.snow.css';
import { getAdmissionDonationById } from '../../../services/donation';
import { DonationSubType, DonationType } from '../../../utils/Constants';

const styleInactiveBreadcrumb = {
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '14px',
  color: 'rgba(79, 88, 103, 0.7)',
  textDecoration: 'none',
  fontFamily: 'BlueberrySans-Regular',
};
const styleActiveBreadcrumb = {
  fontWeight: 600,
  fontSize: '12px',
  lineHeight: '14px',
  color: 'rgba(79, 88, 103, 0.7)',
  textDecoration: 'none',
  fontFamily: 'BlueberrySans-Regular',
};

function detailPenerimaan() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [name, setName] = useState('');
  const [gender, setGender] = useState('');
  const [birthdate, setBirthdate] = useState('');
  const [birthplace, setBirthplace] = useState('');
  const [identityType, setIdentityType] = useState('');
  const [address, setAddress] = useState('');
  const [identityNumber, setIdentityNumber] = useState('');
  const [admissionDate, setAdmissionDate] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [description, setDescription] = useState('');
  const [amount, setAmount] = useState('');
  const [transactionNumber, setTransactionNumber] = useState('');
  const [midtransTransaction, setMidtransTransaction] = useState('');
  const [status, setStatus] = useState('');
  const [programName, setProgramName] = useState('');
  const [donationType, setDonationType] = useState(null);
  const [donationSubType, setDonationSubType] = useState(null);

  useEffect(() => {
    const handleDetailPenerimaan = async () => {
      const detailPenerimaanDonasi = await getAdmissionDonationById(id);
      if (detailPenerimaanDonasi.user !== null) {
        setName(detailPenerimaanDonasi.user.name);
        if (detailPenerimaanDonasi.user.birthdate === null) {
          setBirthdate('-');
        } else {
          const date = moment(detailPenerimaanDonasi.user.birthdate).utc().format('DD-MM-YYYY');
          setBirthdate(date);
        }
        if (detailPenerimaanDonasi.user.identityNumber === null) {
          setIdentityNumber('-');
        } else {
          setIdentityNumber(detailPenerimaanDonasi.user.identityNumber);
        }
        if (detailPenerimaanDonasi.user.birthplace === null) {
          setBirthplace('-');
        } else {
          setBirthplace(detailPenerimaanDonasi.user.birthplace);
        }
        if (detailPenerimaanDonasi.user.address === null) {
          setAddress('-');
        } else {
          setAddress(detailPenerimaanDonasi.user.address);
        }
        if (detailPenerimaanDonasi.user.gender === null) {
          setGender('-');
        } else if (detailPenerimaanDonasi.user.gender === 1) {
          setGender('Laki-laki');
        } else if (detailPenerimaanDonasi.user.gender === 0) {
          setGender('Perempuan');
        }
        if (detailPenerimaanDonasi.user.phoneNumber === null) {
          setPhoneNumber('-');
        } else {
          setPhoneNumber(detailPenerimaanDonasi.user.phoneNumber);
        }
        if (detailPenerimaanDonasi.user.identityType === null) {
          setIdentityType('-');
        } else {
          setIdentityType(detailPenerimaanDonasi.user.identityType);
        }
      } else {
        setName('-');
        setBirthdate('-');
        setBirthplace('-');
        setIdentityType('-');
        setAddress('-');
        setIdentityNumber('-');
        setGender('-');
        setPhoneNumber('-');
      }
      const date = moment(detailPenerimaanDonasi.admissionDate).utc().format('DD-MM-YYYY');
      setAdmissionDate(date);
      setDescription(detailPenerimaanDonasi.description || '-');
      const moneyFormatter = new Intl.NumberFormat();
      const donationFormat = moneyFormatter.format(detailPenerimaanDonasi.amount);
      setAmount(donationFormat.replaceAll(',', '.'));
      setTransactionNumber(detailPenerimaanDonasi.transactionNumber);
      setMidtransTransaction(detailPenerimaanDonasi.midtransTransactionId);
      setStatus(detailPenerimaanDonasi.status);
      setProgramName(detailPenerimaanDonasi.donationProgram.programName);
      setDonationType(DonationType?.find((item) => item.value === detailPenerimaanDonasi.donationProgram.type)?.label);
      if (detailPenerimaanDonasi.donationProgram.subtype) {
        setDonationSubType(DonationSubType?.find((item) => item.value === detailPenerimaanDonasi.donationProgram.subtype)?.label);
      }
    };
    handleDetailPenerimaan();
  }, []);
  return (
    <div className="content-container-side">
      <div className="d-flex">
        <p className="content-title">
          Donasi
        </p>
      </div>
      <div className="mb-4">
        <Breadcrumbs aria-label="breadcrumb" separator="">
          <Link
            color="inherit"
            to="/donasi/penerimaan"
            onClick={() => {
            }}
            style={styleActiveBreadcrumb}
          >
            Penerimaan Dana
          </Link>
          <Typography style={styleInactiveBreadcrumb}>
            Detail Penerimaan Dana
          </Typography>
        </Breadcrumbs>
      </div>
      <Card className="card-datatable">
        <div className="d-flex flex-wrap align-items-center">
          <span
            className="material-icons clickable"
            style={{ marginTop: '-12px' }}
            onClick={() => {
              navigate('/donasi/penerimaan');
            }}
            onKeyPress={() => navigate('/whatnew')}
            role="button"
            tabIndex={0}
          >
            arrow_back
          </span>
          <p className="card-datatable-title ms-3">
            Detail Penerimaan Dana
          </p>
        </div>
        <div className="row">
          <div className="col-lg-6 col-md-12 card-datatable-title">
            Data Donatur
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 col-md-12">
            <Input
              title="Nama"
              name="name"
              type="text"
              value={name}
              disabled
            />
          </div>
          <div className="col-lg-6 col-md-12">
            <Input
              title="Nomor Telepon"
              name="phoneNumber"
              type="text"
              value={phoneNumber}
              disabled
            />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 col-md-12">
            <Input
              title="Gender"
              name="gender"
              type="text"
              value={gender}
              disabled
            />
          </div>
          <div className="col-lg-6 col-md-12">
            <Input
              title="Jenis Kartu Identitas"
              name="identityType"
              type="text"
              value={identityType}
              disabled
            />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 col-md-12">
            <Input
              title="Tempat Tanggal Lahir"
              name="birtdate"
              type="string"
              value={`${birthplace}, ${birthdate}`}
              disabled
            />
          </div>
          <div className="col-lg-6 col-md-12">
            <Input
              title="Nomor Kartu Identitas"
              name="identityNumber"
              type="text"
              value={identityNumber}
              disabled
            />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 col-md-12">
            <Input
              title="Alamat"
              name="address"
              type="text"
              value={address}
              disabled
            />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 col-md-12 card-datatable-title">
            Data Donasi
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 col-md-12">
            <Input
              title="Nomor Transaksi"
              name="transactionNumber"
              type="string"
              value={transactionNumber}
              disabled
            />
          </div>
          <div className="col-lg-6 col-md-12">
            <Input
              title="Nomor Transaksi (Midtrans)"
              name="midtransTransaction"
              type="string"
              value={midtransTransaction}
              disabled
            />
          </div>
          <div className="col-lg-6 col-md-12">
            <InputPrepend2
              label="Jumlah Donasi Yang Masuk"
              title="Rp"
              name="amount"
              type="string"
              value={amount}
              disabled
              width="10%"
            />
          </div>
          <div className="col-lg-6 col-md-12">
            <Input
              title="Status"
              name="status"
              type="text"
              value={status}
              disabled
            />
          </div>
          <div className="col-lg-6 col-md-12">
            <Input
              title="Tanggal Donasi"
              name="admissionDate"
              type="string"
              value={admissionDate}
              disabled
            />
          </div>
          <div className="col-lg-6 col-md-12">
            <Input
              title="Nama Donasi"
              name="programName"
              type="text"
              value={programName}
              disabled
            />
          </div>
          <div className="col-lg-6 col-md-12">
            <Input
              title="Tipe Donasi"
              name="donationType"
              type="text"
              value={donationType}
              disabled
            />
          </div>
          {donationSubType && (
            <div className="col-lg-6 col-md-12">
              <Input
                title="Sub Tipe Donasi"
                name="donationSubType"
                type="text"
                value={donationSubType}
                disabled
              />
            </div>
          )}
          <div className="col-lg-6 col-md-12">
            <Textarea
              title="Keterangan"
              name="description"
              type="textarea"
              value={description}
              rows={10}
              disabled
            />
          </div>
        </div>
      </Card>
    </div>
  );
}

export default detailPenerimaan;
